/**
 * EveryMatrix Sportsbook'un hazır renk şemaları ve imza algoritmaları.
 *
 * Kümeler backend'deki `services/emsports.py` (`THEMES` / `JWT_ALGORITHMS`)
 * ile **aynı kalmalıdır**: sağlayıcı tanımadığı temayı `invalid_theme` ile
 * reddeder ve backend liste dışı değeri 400 ile geri çevirir. Panelde görünüp
 * uygulanamayan bir seçenek "seçtiğim tema kaydedilmiyor" şikâyetinden başka
 * iz bırakmaz.
 *
 * İlk dördü sağlayıcının kendi presetleri, kalanı Flexrix ailesinin ortak
 * paletidir (aynı SPA çekirdeği).
 */
export const EMSPORTS_THEMES = [
  { value: 'dark', label: 'Dark (varsayılan)' },
  { value: 'flexrix', label: 'Flexrix (kehribar)' },
  { value: 'midnight', label: 'Midnight (mavi)' },
  { value: 'emerald', label: 'Emerald (yeşil)' },
  { value: 'flexrix-red', label: 'Flexrix Kırmızı' },
  { value: 'royal-blue', label: 'Royal Mavi' },
  { value: 'emerald-dark', label: 'Zümrüt · Koyu' },
  { value: 'gold-black', label: 'Altın · Siyah' },
  { value: 'purple-velvet', label: 'Mor Kadife' },
  { value: 'light-blue', label: 'Açık Mavi' },
  { value: 'light-crimson', label: 'Açık Kırmızı' },
  { value: 'light-black', label: 'Açık Siyah' },
  { value: 'champagne-gold', label: 'Şampanya Altın' },
  { value: 'forest-green', label: 'Orman Yeşili' },
  { value: 'electric-lime', label: 'Elektrik Yeşili' },
  { value: 'azure-light', label: 'Azur · Açık' },
  { value: 'carbon-silver', label: 'Karbon Gümüş' },
  { value: 'synthwave', label: 'Synthwave' },
  { value: 'sunset-orange', label: 'Gün Batımı Turuncu' },
  { value: 'mint-light', label: 'Nane · Açık' },
  { value: 'rose-gold', label: 'Rose Gold' },
  { value: 'midnight-cyan', label: 'Gece Mavisi' },
  { value: 'navy-amber', label: 'Lacivert · Kehribar' },
  { value: 'olive-tactical', label: 'Haki' },
  { value: 'blood-orange', label: 'Kan Portakalı' },
  { value: 'amber-graphite', label: 'Kehribar · Grafit' },
  { value: 'monochrome-dark', label: 'Tek Renk · Koyu' },
];

// HS256 varsayılandır: anahtar zaten `api_secret`'tir ve kurulum tek bir sır
// taşır. RS256 yalnızca sağlayıcıya ayrı bir açık anahtar veren kurulumlar
// içindir ve özel anahtarın panele girilmesini gerektirir.
export const EMSPORTS_JWT_ALGORITHMS = [
  { value: 'HS256', label: 'HS256 (API secret ile) — önerilen' },
  { value: 'RS256', label: 'RS256 (RSA açık/özel anahtar)' },
];

// SPA'nın dili. Sağlayıcının desteklediği kümenin, sitenin kullandığı
// dillerle kesişimidir.
export const EMSPORTS_LANGUAGES = [
  { value: 'tr', label: 'Türkçe' },
  { value: 'en', label: 'İngilizce' },
  { value: 'de', label: 'Almanca' },
  { value: 'es', label: 'İspanyolca' },
  { value: 'ru', label: 'Rusça' },
  { value: 'az', label: 'Azerbaycan Türkçesi' },
];

export default EMSPORTS_THEMES;
